import { Box, BoxProps, ColorOptions, Icon, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../../components/AdminButton'
import React, { ReactElement, useState } from 'react'
import ReactDOM from 'react-dom'
import { ApiConfig } from '../../../components/ApiConfig'
import { VerticalStepIndicator } from '../../../components/VerticalStepIndicator'
import { PaymentConfig } from '../../PaymentConfig'
import { BusinessDetails } from './BusinessDetails'
import { CreateEntity } from './CreateEntity'
import EmApiOnboarding from './EmApiOnboarding'
import { EmGeneralConfig } from './EMGeneralConfig'
import { EntityDetails } from './EntityDetails'
import { PartnerProcessorSettings } from './PartnerProcessorSettings'
import { ProfileDetails } from './ProfileDetails'
import { ProgramDetails } from './ProgramDetails'
import { SettlementDetails } from './SettlementDetails'

const steps = [
  'Create Entity',
  'Entity Details',
  'Profile Details',
  'Business Details',
  'Program Details',
  'General Configuration',
  'Payment Configuration',
  'Bank/Partner Config',
  'Settlement Details',
  'API Onboarding',
  'API Configuration',
]

const EntityOnboarding = ({ visible, setVisible }: any) => {
  const [currentStep, setCurrentStep] = useState(1)
  const [accessData, setAccessData] = useState([])

  //   useEffect(() => {
  //     if (state === 'fulfilled') {
  //       if (currentStep !== 2) {
  //         setCurrentStep(currentStep + 1)
  //       } else {
  //       }
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [state])

  if (!visible) {
    return null
  }

  const Header = () => {
    return (
      <Box {...styles.header}>
        <Text title={'Entity Onboarding'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <Box onPress={() => [setVisible(false), setCurrentStep(1)]}>
          <Icon id={'CLOSE'} size={20} />
        </Box>
      </Box>
    )
  }
  const Footer = () => {
    const titles: any = {
      1: 'Save & Proceed To Entity Details',
      2: 'Save & Proceed To Profile Details',
      3: 'Save & Proceed To Business Details',
      4: 'Save & Proceed To Program Details',
      5: 'Save & Proceed To General Configuration',
      6: 'Save & Proceed To Payment Configuration',
      7: 'Save & Proceed To Bank/Partner configuration',
      8: 'Save & Proceed To Settlement Details',
      9: 'Save & Proceed To API Onboarding',
      10: 'Save & Proceed To API Configuration',
      11: 'Save & Submit',
    }
    const handleFooterPress = () => {
      setCurrentStep(currentStep + 1)
    }

    const isGeneralConfigValid = true
    const isValid: any = {
      1: true,
      2: true,
      3: true,
      4: true,
      5: true,
      6: true,
      7: true,
      8: true,
      9: true,
      10: true,
      11: true,
    }
    return (
      <Box {...styles.footer}>
        <ButtonNew
          onPress={handleFooterPress}
          title={titles[currentStep] ?? 'Save & Submit'}
          width={320}
          height={40}
          isLoading={false} //state === 'pending'
          disabled={!isValid[currentStep]}
        />
      </Box>
    )
  }
  const renderEntityOnboarding = (): ReactElement => {
    const getScreen: any = {
      1: <CreateEntity type={''} />,
      2: <EntityDetails />,
      3: <ProfileDetails />,
      4: <BusinessDetails />,
      5: <ProgramDetails />,
      6: <EmGeneralConfig />,
      7: <PaymentConfig type={'EM'} />,
      8: <PartnerProcessorSettings />,
      9: <SettlementDetails />,
      10: <EmApiOnboarding showSuccess />,
      11: <ApiConfig accessData={accessData} type={'EM'} isOnboarding={false} />,
    }
    return (
      <Box {...styles.modal}>
        <Box {...styles.container}>
          <Header />
          <Box flexDirection={'row'} f={1}>
            <Box w={220}>
              <VerticalStepIndicator currentStep={currentStep} steps={steps} />
            </Box>
            <Box flexGrow={1} f={1}>
              {getScreen[currentStep]}
            </Box>
          </Box>
          <Footer />
        </Box>
      </Box>
    )
  }
  return ReactDOM.createPortal(renderEntityOnboarding(), document.body)
}

const styles = {
  modal: {
    position: 'absolute',
    elevation: 2,
    shadowOpacity: 1,
    opacity: 1,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: '#0000001F' as ColorOptions,
    zIndex: 1,
    align: 'center',
    justify: 'center',
    borderColor: 'GRAY_BORDER',
    backgroundColor: '#00000080' as ColorOptions,
  } as BoxProps,
  container: {
    backgroundColor: 'WHITE',
    borderRadius: 8,
    shadowRadius: 3,
    w: '70%',
    h: '95%',
    shadowColor: '#0000001F' as ColorOptions,
    zIndex: 1,
  } as BoxProps,
  header: {
    flexDirection: 'row',
    p: 24,
    justify: 'space-between',
    align: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#0000001F' as ColorOptions,
  } as BoxProps,
  footer: {
    p: 16,
    justify: 'center',
    align: 'flex-end',
    borderTopWidth: 1,
    borderTopColor: '#0000001F' as ColorOptions,
  } as BoxProps,
}
export default EntityOnboarding
